import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

  go(event) {
    location.href = event.params.go;
  }
}
